export default __webpack_public_path__ + "static/media/P30002.fa87bed4.png";